import { isBrowser } from '@/utils/isBrowser'
import { businessUnit } from '@/utils/themes/theme'

export const toElasticSearch = (
  filter,
  pagination,
  extraMustElasticClauses = {},
  extraElasticClauses = {},
  extraElasticClausesAsArray = [],
  sortParam = 'createdAt'
) =>
  JSON.stringify({
    ...pagination,
    sort: Array.isArray(sortParam) ? getSortParameters(sortParam) : [getSort(sortParam)],
    query: {
      bool: {
        must: filterToElasticClauses(getFiltersWithDates({ ...filter }))
          .concat(Object.keys(extraMustElasticClauses).length ? [extraMustElasticClauses] : [])
          .concat(extraElasticClausesAsArray || [])
          .concat([
            {
              term: {
                'businessUnit.keyword': isBrowser() ? businessUnit(globalThis?.location?.hostname) : 'BOT'
              }
            }
          ]),
        ...extraElasticClauses
      }
    }
  })

export const filterToElasticClauses = (filter) =>
  Object.keys(filter)
    .filter((clause) => filter[clause])
    .reduce((previous, clause) => {
      switch (true) {
        case isClauseADate(clause):
          return [...previous, getDateSearchClause(clause, filter, 'term')]
        case isClauseADateRange(clause, filter):
          return [...previous, getDateSearchClause(clause, filter, 'range')]
        case Array.isArray(filter[clause]):
          return [
            ...previous,
            {
              bool: {
                should: filter[clause]?.map((filterValue) => getStringSearchClause(clause, { [clause]: filterValue }))
              }
            }
          ]
        default:
          return [...previous, getStringSearchClause(clause, filter)]
      }
    }, [])

export const getStringSearchClause = (clause, filter) => ({
  match_phrase_prefix: {
    [`${clause}`]: `${filter[clause]}`
  }
})

export const getDateSearchClause = (clause, filter, type) => ({
  [`${type}`]: {
    [`${clause}`]: filter[clause]
  }
})

export const getSort = (sortParam) => {
  const defaultSort = {
    [`${sortParam}`]: { order: 'desc' }
  }

  return sortParam === 'eventDate' ? Object.assign(defaultSort, { expirationDate: { order: 'desc' } }) : defaultSort
}

export const getSortParameters = (sortParams) =>
  sortParams.map((sortParam) => ({ [`${sortParam}`]: { order: 'desc' } }))
export const isClauseADateRange = (clause, filter) => Boolean(filter[clause]?.lte && filter[clause]?.gte)

export const isClauseADate = (clause) => Boolean(clause === 'birthDate')

export const getFiltersWithDates = (filter) => {
  const cleanFilter = filter
  Object.keys(cleanFilter).forEach((clause) => {
    if (clause.includes('-from')) {
      const key = clause.replace('-from', '')
      cleanFilter[key] = {
        gte: cleanFilter[`${key}-from`],
        lte: cleanFilter[`${key}-to`]
      }
      delete cleanFilter[`${key}-from`]
      delete cleanFilter[`${key}-to`]
    }
  })
  return cleanFilter
}
